import React, { useState } from 'react'
import { AiFillProject, AiOutlinePlus } from 'react-icons/ai'
import { BsFillPlusCircleFill, BsPlusLg } from 'react-icons/bs'
import { FaPlus, FaTasks } from 'react-icons/fa'
import { HiCurrencyRupee, HiHome, HiPlus, HiUsers } from 'react-icons/hi'
import { IoMdSettings } from 'react-icons/io'
import styles from "./Styles/BottomNav.module.css"
import bottomNav from "../Assets/bottomNav.svg"
import { useLocation, useNavigate } from 'react-router-dom'

export default function BottomNav() {

  const [selectedTab, setSelectedTab] = useState('Home')  
  const navigate = useNavigate()
  const location = useLocation()
  return (
    <nav className={styles.nav}>
        {/* <img src={bottomNav} /> */}
        <div className={styles.navLinks}>
            <div onClick={()=>{
                    navigate('/dashboard/home')
                    setSelectedTab('Home')
                }} className={location.pathname.includes('dashboard/home') && styles.activeTab}>
                <HiHome size={26} color={location.pathname.includes('dashboard/home') ? '#299EFE' : "#B2B2B2"} />
                <p>Home</p>
            </div>
            <div onClick={()=>{
                navigate('/dashboard/leads')
                setSelectedTab('Leads')
            }} className={location.pathname.includes('dashboard/leads') && styles.activeTab}>
                <HiUsers size={26} color={location.pathname.includes('dashboard/leads')  ? '#299EFE' : "#B2B2B2"} />
                <p>Leads</p>
            </div>
            <div onClick={()=>{
                navigate('/dashboard/projects')
                setSelectedTab('Projects')
                }} className={location.pathname.includes('dashboard/projects') && styles.activeTab}>
                <AiFillProject size={26} color={location.pathname.includes('dashboard/projects') ? '#299EFE' : "#B2B2B2"} />
                <p>Projects</p>
            </div>
            <span onClick={()=>navigate('/quiz')} className={styles.plusIcon}>
                <BsPlusLg size={40} color="#fff"  />
            </span>
            <div onClick={()=>{
                navigate('/dashboard/finance')
                setSelectedTab('Finance')
                }} className={location.pathname.includes('dashboard/finance')  && styles.activeTab}>
                <HiCurrencyRupee size={26} color={location.pathname.includes('dashboard/finance')  ? '#299EFE' : "#B2B2B2"} />
                <p>Finance</p>
            </div>
            <div onClick={()=>{
                navigate('/dashboard/tasks')
                setSelectedTab('Tasks')
                }} className={location.pathname.includes('dashboard/tasks') && styles.activeTab}>
                <FaTasks size={26} color={location.pathname.includes('dashboard/tasks') ? '#299EFE' : "#B2B2B2"} />
                <p>Tasks</p>
            </div>
            <div onClick={()=>{
                navigate('/dashboard/settings')
                setSelectedTab('Settings')
                }} className={location.pathname.includes('dashboard/settings') && styles.activeTab}>
                <IoMdSettings size={26} color={location.pathname.includes('dashboard/settings') ? '#299EFE' : "#B2B2B2"} />
                <p>Settings</p>
            </div>
        </div>
    </nav>
  )
}
